import Web3 from 'web3'

export function toWei(value) {
  return Web3.utils.toWei(value.toString(), 'ether')
}

export default new Web3(Web3.givenProvider || process.env.VUE_APP_RPC)
